<!--казарма / конюшня / мастерская / резиденция / целебный шатер-->

<template>
	<div class="arrowsHidden rows_1" :class="['col_'+cols]">
		<div class="carousel">
			<div class="pages" v-if="pager.totalPages > 1" :class="{
				'firstPage': pager.currentPage == 1,
				'lastPage': pager.currentPage == pager.totalPages,
			}">
				<div class="iconButton doubleBorder arrowDirectionFrom" @click="onPreviousPage()">
					<i v-if="!arrowClass" class="symbol_arrowFrom_tiny_flat_black"></i>
				</div>
				<div class="page clickable" v-for="page in range(1, pager.totalPages)" :key="page" @click="setPage(page)" :class="{
					'active': page == pager.currentPage,
				}"></div>
				<div class="iconButton doubleBorder arrowDirectionTo" @click="onNextPage()">
					<i v-if="!arrowClass" class="symbol_arrowTo_tiny_flat_black"></i>
				</div>
			</div>
			<div class="itemContainer">
				<div class="items" style="width: 295px;">
					<div v-for="item in itemsOnPage">
						<div class="item unit train" style="width: 145px;">
							<div class="clickableContainer clickable" @click="onSelectItem(item)" :class="{
								'active': activeItem.type == item.type,
							}">
								<img src="//iwstatic.g.bsrv.su/img/x.gif" size="thumb" class="itemImage gaul unitThumb" :class="['unitType'+item.type]" data-cmp-info="10" />
								<div class="itemHead">
									<span><span>{{item.name}}</span></span>
								</div>
								<div class="horizontalLine double"></div>
								<div class="queueLimit" v-if="item.limit >= 0 && !item.disabled">{{item.limit}}</div>
								<!-- ngIf: item.queue && item.queue.key > 0 && carouselActiveItem.unitType === item.unitType -->
								<div class="makeFirst clickable" clickable="carouselCallback(item)" v-if="item.queue && item.queue.key > 0 && activeItem.type === item.type" tooltip="Сначала обучить это войско" tooltip-translate="Troop.MoveInQueue.Tooltip">
									<div class="moveLabel" translate=""><span>Вперед</span></div>
									<div class="moveArrow">
										<div class="doubleArrow"></div>
									</div>
								</div>
								<div class="itemBody">
									<div class="symbol_lock_medium_wrapper" v-if="item.disabled">
										<i class="symbol_academy_medium_flat_black"></i>
									</div>
									<div class="symbol_lock_medium_wrapper" v-if="item.existing <= 0">
										<i class="symbol_lock_medium_flat_black"></i>
									</div>
									<div class="lockExplain" v-if="item.disabled">
										<div class="content">
											<span><span>Где изучить: </span><a class="buildingLink clickable" clickable="$root.openWindow('building', {'location': 'type22'})" building-type="22">Академия</a></span>
										</div>
									</div>
									<div class="lockExplain" v-if="item.existing <= 0">
										<div class="content">
											<span><span>Нет свободных слотов</span></span>
										</div>
									</div>
									<div class="progressContainer" v-if="item.queue.count > 0" :class="{'paused': item.queue.pause > 0}">
										<div class="queueAmount" v-if="item.queue.count > 0">
											<div class="amount">{{item.queue.count}}</div>
										</div>
										<div class="progressbar" v-if="item.queue.pause <= 0" finish-time="1721230729" finish-time-total="1721239524" duration="8795" show-countdown="true" content="<span options='Units.Build.Tooltip.unitTime'><span countdown='1723708724' callback=''>00:02:43</span><span> до конца обучения воина</span></span>" v-tippy="{placement: 'top'}" tooltip-placement="above" tooltip-translate="Units.Build.Tooltip.unitTime" tooltip-data="time:1721230729">
											<!-- ngIf: ::labelIcon -->
											<div class="progress">
												<!-- ngIf: steps -->
												<div class="bar positive perc " style="z-index: 2; width: 9.7%;"></div>
												<div class="bar additionalBar additionalPerc"></div>
												<div class="marker">
													<div class="markerInner"></div>
												</div>
												<div ng-if="::showCountdown" class="countdown" countdown="1721239524">10:17:16</div>
												<!-- ngIf: ::label -->
												<!-- ngIf: ::percTooltip -->
											</div>
										</div>
										<!-- ngIf: item.queue.pause > 0 -->
										<!-- ngIf: item.queue.pause > 0 -->
										<div class="additionalInfo" v-if="!item.disabled">
											<i class="action_setMax_tiny_flat_black"></i>
											<!--максимально доступное количество этих юнитов-->
											<span>{{item.existing}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-for="i in range(1, cols - itemsOnPage.length)" class="item dummy" style="width: 145px;"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	
</style>

<script>
import lib from '@/lib';
import paginate from 'jw-paginate';

export default {
	mixins: lib.mixins,
	props: {
		items: {
			type: Array,
			default: [],
		},
		cols: {
			type: Number,
			default: 4,
		},
		arrowClass: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['onActiveItem'],
	data: () => ({
		itemsOnPage: [],
		pager: {},
		
		currentPage: 1,
		activeItem: null,
	}),
	computed: {},
	watch: {
		items: {
			handler(val, oldVal) {
				if(this.pager){
					this.setPage(this.pager.currentPage);
				} else {
					this.setPage(1);
				}
			},
			deep: true,
		},
	},
	methods: {
		range: lib.range,
		getPercent: lib.getPercent,
		
		onNextPage(){
			if(this.pager.currentPage < this.pager.totalPages){
				this.setPage(this.pager.currentPage + 1);
			} else {
				this.setPage(1);
			}
		},
		onPreviousPage(){
			if(this.pager.currentPage > 1){
				this.setPage(this.pager.currentPage - 1);
			} else {
				this.setPage(this.pager.totalPages);
			}
		},
		setPage(page){
			const { items } = this;
			const pager = paginate(items.length, page, 4, 10);
			this.itemsOnPage = items.slice(pager.startIndex, pager.endIndex + 1);
			this.pager = pager;
		},
		onSelectItem(item){
			this.activeItem = item;
			this.$emit('onActiveItem', item);
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_21.ogg');
				audio.play();
			}
		},
	},
	created(){
		this.setPage(1);
		if(this.items.length > 0){
			this.onSelectItem(this.items[0]);
		}
	},
	components: {},
}
</script>